import { useNode } from '@craftjs/core';
import {
  TitlePanel,
  AnswersPanel,
  LayoutPanel,
  ValidationPanel,
  LogicPanel,
} from 'src/features/generalForms/builder/layout/panels';
import { FormDateInputComponent, FormDateInputProps } from 'src/features/generalForms/builder/types/DateInput';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';
import { AppTextField } from 'src/features/generalForms/uikit/fields/text/textField';

export const FormDateInput: FormDateInputComponent = (props) => {
  const {
    connectors,
    styles,
    actions: { setProp },
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const { connect, drag } = connectors;
  const validationResult = useDataKeyValidation();

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={styles}>
      <AppTextField
        type={'date'}
        disabled={props.disabled}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        value={props.defaultValue || ''}
        onChange={(e) =>
          setProp((p: FormDateInputProps) => {
            p.defaultValue = e.target.value || undefined;
          }, 500)
        }
        errorProps={{ errors: validationResult?.message }}
      />
    </div>
  );
};

export const FormDateInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <AnswersPanel />
    <LayoutPanel sections={['Paddings']} />
    <ValidationPanel type={'date'} sections={['MinMax']} />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormDateInput.craft = {
  displayName: 'Date',
  rules: { canDrag: () => true },
  related: { settings: FormDateInputSettings },
};
